import type { WatchQueryFetchPolicy } from '@apollo/client';
import { useQuery } from '@apollo/client';
import ALL_INTEGRATIONS_QUERY from '../graphql/allIntegrations';

const buildMap = <T extends { platform: string }>(
  integrations: T[] = [],
): Record<string, T> =>
  integrations.reduce(
    (memo, integration) => ({
      ...memo,
      [integration.platform]: integration,
    }),
    {},
  );

const useIntegrationMap = ({
  fetchPolicy,
}: { fetchPolicy?: WatchQueryFetchPolicy } = {}) => {
  const result = useQuery(ALL_INTEGRATIONS_QUERY, { fetchPolicy });

  const map = buildMap(result.data?.session.organization.integrations ?? []);

  return [map, result] as const;
};

export default useIntegrationMap;
